import { useState, useCallback } from 'react';
import { checkStatus, fetchAuthenticated } from "utils/request";

const useStarfishAPI = (config = {}) => {
  const initialData = typeof config.initialData === "undefined" 
    ? {} 
    : config.initialData;

  const initialState = { 
    data: initialData,
    requestComplete: false, // Request to the API call has been completed or not
    success: false,
    pending: false, 
    error: null 
  };

  const redirectOnSessionTimeout = httpStatusCode => httpStatusCode === 423 ? window.location = '../support/sessionTimeout.html' : null;

  const [response, setResponse] = useState(initialState);

  const callAPI = async (URL, options = { method: 'GET' }) => {
    let httpStatusCode = null;
    setResponse({...response, success: false, pending: true, error: null, httpStatusCode});
    try {
      const serverResponse = await fetchAuthenticated(URL, options);
      httpStatusCode = serverResponse.status;
      const checkStatusResponse = await checkStatus(serverResponse);
      // Make sure that we skip JSON conversion if status code is 204 and it is a new API
      let data = initialData;
      redirectOnSessionTimeout(httpStatusCode);
      if ( httpStatusCode !== 204 || !config.isNewAPI ) {
        data = await checkStatusResponse.json();
      }
      const apiResponse = {
        data,
        // For new APIs, all 2xx status are considered success
        success: config.isNewAPI === true ? true : data.success,
        requestComplete: true,
        pending: false,
        error: data.success === false
            ? (data.message || "There was an error fetching the API.")
            : null,
        httpStatusCode
      };
      setResponse(apiResponse);
      return apiResponse;
    } catch(e) {
      redirectOnSessionTimeout(httpStatusCode);
      const apiResponse = {
            data: response.data,
            requestComplete: true,
            success: false,
            pending: false,
            error: e.json ? (e.json.message || e.json.userMessage) : e.message,
            httpStatusCode
      };
      setResponse(apiResponse);
      return apiResponse;
    }
  }

  // Auxiliary functions to clear/reset values from hooked components
  const clearError = () => setResponse({...response, error: null});
  const clearData = () => setResponse({...response, data: initialData});
  const resetResponse = () => setResponse(initialData);

  return [response, callAPI, { clearError, clearData, resetResponse: useCallback(resetResponse, []) }];
}

export default useStarfishAPI;
